var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoom2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1213 2.90909C20.6568 2.90909 21.091 3.34324 21.091 3.87879V13.5758C21.091 14.1113 20.6568 14.5455 20.1213 14.5455H14.5455V20.1212C14.5455 20.6568 14.1114 21.0909 13.5758 21.0909H3.87888C3.34333 21.0909 2.90918 20.6568 2.90918 20.1212V3.87879C2.90918 3.34324 3.34333 2.90909 3.87888 2.90909H20.1213ZM4.84857 19.1515H12.6061V13.5758C12.6061 13.0402 13.0403 12.6061 13.5758 12.6061H19.1516V4.84848H4.84857V19.1515Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoom2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/room_2.012ed0eef05bc083be27b7afd0e50dc2.svg";